import React from "react";
import Container from "../components/style/ContainerStyle";
import Navbar from "../components/Navbar";
import AboutBox from "../components/AboutBox";

const About = () => {
  return (
    <Container>
      <Navbar />
      <AboutBox />
    </Container>
  );
};

export default About;
